// Redirect-on-submit forms for the message-generator and countdown landing
// pages. Deliberately not part of the main app bundle (js/main.js) — these
// just build a URL and navigate, reusing the existing msg/until/since URL
// modes rather than adding any new rendering logic. Runs standalone; no-ops
// if a given form isn't on the page.

document.addEventListener('DOMContentLoaded', () => {
  const msgForm = document.getElementById('landing-msg-form');
  if (msgForm) {
    msgForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = document.getElementById('landing-msg-text');
      const text = (input?.value || '').trim();
      if (!text) return;
      const slug = text.replace(/\s+/g, '-');
      window.location.href = `/message-generator/${encodeURIComponent(slug)}`;
    });
  }

  const countdownForm = document.getElementById('landing-countdown-form');
  if (countdownForm) {
    countdownForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const direction = document.querySelector('input[name="landing-direction"]:checked')?.value || 'until';
      const dateVal = document.getElementById('landing-countdown-date')?.value || '';
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateVal)) return;
      const labelRaw = (document.getElementById('landing-countdown-label')?.value || '').trim();
      const labelSlug = labelRaw.replace(/\s+/g, '-');
      const path = labelSlug
        ? `/${direction}/${dateVal}/${encodeURIComponent(labelSlug)}`
        : `/${direction}/${dateVal}`;
      window.location.href = path;
    });
  }
});
